export const ERROR_ON_USERS_API = (userId: string) => `[ER-PER-01] - Failed to get users license for user ${userId}`;
export const ERROR_ON_LICENSE_API = (userId: string) => `[ER-PER-02] - Failed to get license inheritance for user ${userId}`;
